export default function OfficialcategoriesTableColumnDefinition(local) {
  return [{
    type: 'string',
    field: 'name',
    headerName: local.name,
    minWidth: 150,
    flex: 1,
  }];
}
